export default "__VITE_ASSET__y2MUAJ9n__"